import styled from '@emotion/styled';
import React from 'react';
import { getColor } from './UICommon';

const loaderBgStyle = `no-repeat radial-gradient(circle closest-side, ${getColor('GRAY_70')} 90%, #0000)`;

const Loader = styled.div`
  margin: auto;
  width: 40px;
  aspect-ratio: 2;
  background: ${loaderBgStyle} 0% 50%, ${loaderBgStyle} 50% 50%, ${loaderBgStyle} 100% 50%;
  background-size: calc(100% / 3) 50%;
  animation: loaderKeyFrames 1s infinite linear;
  @keyframes loaderKeyFrames {
    20% {
      background-position: 0% 0%, 50% 50%, 100% 50%;
    }
    40% {
      background-position: 0% 100%, 50% 0%, 100% 50%;
    }
    60% {
      background-position: 0% 50%, 50% 100%, 100% 0%;
    }
    80% {
      background-position: 0% 50%, 50% 50%, 100% 100%;
    }
  }
`;

export const ThreeDotsLoader: React.FC = () => {
  return <Loader />;
};
